import { ActionTypes as HomeActions } from "../home/Home.actions";
import { ActionTypes as MessagesActions } from "../messages/Messages.actions";

const getDateKey = (a) => a.applicationDate.slice(0, 10);
const getYear = (d) => d.slice(0, 4);

export default (_store) => (next) => (action) => {
	const { type, payload, ...others } = action;
	switch (type) {
		case HomeActions.fetchApplicationsCompleted: {
			const { applications, ...rest } = payload;
			const daysOrder = applications
				? [...new Set(applications.map(getDateKey))].sort(
						(a, b) => new Date(b) - new Date(a),
					)
				: [];
			const years = [...new Set(daysOrder.map(getYear))];
			const days = {};
			daysOrder.forEach((d) => {
				days[d] = applications
					.filter((a) => a.applicationDate.indexOf(d) !== -1)
					.map((a) => a.applicationId);
			});
			return next({
				type,
				payload: { applications, days, years, daysOrder, ...rest },
				...others,
			});
		}
		case MessagesActions.fetchMessagesFromThreadCompleted: {
			const { messages, ...rest } = payload;
			const { days, datesOrder } = getDaysAndOrder(messages);
			return next({
				type,
				payload: { messages, days, datesOrder, ...rest },
				...others,
			});
		}
		default:
			return next({ type, payload, ...others });
	}
};

export function getDaysAndOrder(messages, _datesOrder = []) {
	const datesOrder = messages
		? [
				...new Set([
					...messages.map((m) => m.createDate.slice(0, 10)),
					..._datesOrder,
				]),
			].sort((a, b) => new Date(b) - new Date(a))
		: [];
	const days = {};
	datesOrder.forEach((date) => {
		days[date] = messages.filter(
			(message) => message.createDate.indexOf(date) !== -1,
		);
	});
	return { days, datesOrder };
}
